import { ListUpdatesResponse } from '@ditto/shared';

const PRIORITY_ORDER: Record<string, number> = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
  none: 0,
};

export type ReviewSortMode = 'priority' | 'date';

export const REVIEW_SORT_MODE_LABELS: Record<ReviewSortMode, string> = {
  priority: 'Priority',
  date: 'Date',
};

export const sortReviewUpdatesByPriority = (
  a: ListUpdatesResponse,
  b: ListUpdatesResponse
): number => {
  // 1. Higher priority first
  const aPriority = PRIORITY_ORDER[a.context?.priority ?? 'none'] ?? 0;
  const bPriority = PRIORITY_ORDER[b.context?.priority ?? 'none'] ?? 0;
  if (aPriority !== bPriority) return bPriority - aPriority;

  // 2. Most recent publicationDate first
  return sortReviewUpdatesByDate(a, b);
};

export const sortReviewUpdatesByDate = (
  a: ListUpdatesResponse,
  b: ListUpdatesResponse
): number => {
  const aDate = new Date(a.update.publicationDate).getTime();
  const bDate = new Date(b.update.publicationDate).getTime();
  return bDate - aDate;
};
